import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { AcceptChargesModel, PrintPalletLabelModel, RemovePackingPalletModel, SaveProNumberPayload, SaveShippingDataModel, SaveShippingPalletModel } from '../models/buy-shipping.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BuyShippingService implements OnDestroy{
  private url = 'api/buyshipping'; 
  private truckerUrl = 'api/Trucker'; 
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  options = { headers: this.headers };
  private destroy$ = new Subject<void>();
  constructor(private http: HttpClient) { }

  getBuyShipping(shipmentHeaderId:any){
    return this.http.get(
      `/${this.url}/GetBuyShipping?ShipmentHeaderId=${shipmentHeaderId}`,
      this.options
    );
  }

  removeShippingPallet(payload:RemovePackingPalletModel) {
    return this.http.post(
      `/${this.url}/RemoveShipmentPackingPallet`,
      payload,
      this.options
    );
  }

  GetShipmentPackingPallet(shipmentHeaderId: number) {
    return this.http.get(
      `/${this.url}/GetShipmentPackingPallet?ShipmentHeaderID=${shipmentHeaderId}`,
    );
  }

  saveShipmentPackingPallet(payload:SaveShippingPalletModel){
    return this.http.post(
      `/${this.url}/saveShipmentPackingPallet`,
      payload,
      this.options
    )
  }

  confirmTransport(payload :AcceptChargesModel){
    return this.http.post(
      `/${this.url}/ConfirmTransport`,
      payload,
      this.options
    );
  }
  voidTransport(payload){
    return this.http.post(
      `/${this.url}/VoidTransport`,
      payload,
      this.options
    );
  }

  saveBuyShipping(payload :SaveShippingDataModel){
    return this.http.post(
      `/${this.url}/SaveBuyShipping`,payload,this.options
    );
  }

  saveProNumber(payload:SaveProNumberPayload){
    return this.http.post(
      `/${this.url}/SaveProNumber`,payload,this.options
    );
  }

  printPalletLabel(payload:PrintPalletLabelModel){
    return this.http.get(
      `/${this.url}/GetLabel?PageType=${payload.pageType}&LabelType=${payload.labelType}&ShipmentHeaderId=${payload.shipmentHeaderId}${payload.numberOfPallets != null ? "&NumberOfPallets=" + payload.numberOfPallets : ""}`,
    );
  }  

  UpdateBoxDimension(payload){
    return this.http.post(`/${this.url}/UpdateBoxDimension/`, payload, this.options);  
  } 

  getShipmentBOL(shipmentHeaderId:number){
    return this.http.get(
      `/${this.url}/GetShipmentBOL?ShipmentHeaderID=${shipmentHeaderId}`,
    );
  }

  getRateForOtherCarrier(payload){
    return this.http.post(`/${this.truckerUrl}/SubmitBid`, payload,this.options);
  }

  applyCharges(payload){
    return this.http.post(`/${this.truckerUrl}/AcceptBid`, payload,this.options);
  }

  getBids(shipmentHeaderId:number,accountType:string){
    return this.http.get(`/${this.truckerUrl}/GetBidsByShipmentId?ShipmentHeaderID=${shipmentHeaderId}&AccountType=${accountType}`,
    );
  }

  CancelBid(payload){
    return this.http.post(`/${this.truckerUrl}/CancelBid`, payload,this.options);
  }

  updateShipmentContactInfo(payload){
    return this.http.post(
      `/${this.truckerUrl}/UpdateShipmentContactInfo`,payload,this.options
    );
  }

  getTruckers(){
    return this.http.get(`/${this.truckerUrl}/GetTruckerList`,this.options);
  }

  getShippingContact(qry=""){
    return this.http.get(`/${this.url}/GetShippingContact?Qry=`+qry,this.options);
  }

  saveShippingContact(payload){
    return this.http.post(
      `/${this.url}/SaveShippingContact`,payload,this.options
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
